var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 81,
    viewBox: "0 0 204 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.4634,
    y: -29.0231,
    width: 63.0854,
    height: 63.0854,
    rx: 7.00486,
    fill: "white",
    fillOpacity: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.349609,
    y: -3.04442,
    width: 63.0854,
    height: 63.0854,
    rx: 7.00486,
    fill: "white",
    fillOpacity: 0.13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.942,
    y: 16.0038,
    width: 29.7706,
    height: 29.7706,
    rx: 7.00486,
    fill: "white",
    fillOpacity: 0.13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.429,
    y: 28.2599,
    width: 29.7706,
    height: 29.7706,
    rx: 7.00486,
    fill: "white",
    fillOpacity: 0.13
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 181.398,
    y: 49.0288,
    width: 21.9736,
    height: 21.9736,
    rx: 7.00486,
    fill: "white",
    fillOpacity: 0.13
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168.472,
    y: 58.0751,
    width: 21.9736,
    height: 21.9736,
    rx: 7.00486,
    fill: "white",
    fillOpacity: 0.13
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDesign);
export default __webpack_public_path__ + "static/media/box-design.69ccd98a7f3146ac2636717046c15901.svg";
export { ForwardRef as ReactComponent };